import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { openNewsletterModal } from '../../../ducks/newsletter.duck';

import { shopLink } from '../../../marketplace-links';
import routeConfiguration from '../../../routeConfiguration';
import useAppSelector from '../../../util/hooks/useAppSelector';
import { createResourceLocatorString } from '../../../util/routes';
import BoxSeparator from '../../BoxSeperator/BoxSeparator';
import Link from '../../Links/Link/Link';

const buttonLinkStyle = { justifyContent: 'space-between' };

const SectionCommunityComponent = ({ onClose }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const currentUser = useAppSelector((state) => state.user.currentUser);

  const currentUserGettingNewsletter =
    currentUser?.attributes.profile.privateData.notificationSettings?.email?.newsLetter ||
    currentUser?.attributes.profile.protectedData.approvedForNewsletter;
  const canSignUpForNewsletter = !currentUser || (currentUser && !currentUserGettingNewsletter);

  return (
    <>
      <BoxSeparator />
      <Stack px={4}>
        <Typography gutterBottom variant="h5">
          <FormattedMessage id="AccountBottomBarBox.community" />
        </Typography>
        {canSignUpForNewsletter ? (
          <Button
            color="secondary"
            fullWidth
            onClick={() => dispatch(openNewsletterModal())}
            sx={buttonLinkStyle}
          >
            <FormattedMessage id="AccountBottomBarBox.newsletter" />
            <ChevronRightIcon color="secondary" />
          </Button>
        ) : null}
        {intl.locale === 'de' ? (
          <>
            <Button
              color="secondary"
              href={shopLink}
              rel="noreferrer"
              sx={buttonLinkStyle}
              target="_self"
            >
              <FormattedMessage id="AccountBottomBarBox.shop" />
              <ChevronRightIcon color="secondary" />
            </Button>
            <Button
              color="secondary"
              component={Link}
              fullWidth
              onClick={onClose}
              sx={buttonLinkStyle}
              to={createResourceLocatorString(
                'StoryblokPage',
                routeConfiguration(),
                { slug: 'stellplatzfuehrer' },
                {},
                intl.locale,
              )}
            >
              <FormattedMessage id="AccountBottomBarBox.spotsGuide" />
              <ChevronRightIcon color="secondary" />
            </Button>
            <Button
              color="secondary"
              component={Link}
              fullWidth
              onClick={onClose}
              sx={buttonLinkStyle}
              to="https://shop.vansite.eu/collections/camping-geschenk-ideen"
            >
              <FormattedMessage id="AccountBottomBarBox.travelProtection" />
              <ChevronRightIcon color="secondary" />
            </Button>
          </>
        ) : null}
        <Button
          color="secondary"
          component={Link}
          fullWidth
          onClick={onClose}
          sx={buttonLinkStyle}
          to={createResourceLocatorString(
            'StoryblokPage',
            routeConfiguration(),
            { slug: 'blog' },
            {},
            intl.locale,
          )}
        >
          <FormattedMessage id="AccountBottomBarBox.blog" />
          <ChevronRightIcon color="secondary" />
        </Button>
      </Stack>
    </>
  );
};

SectionCommunityComponent.displayName = 'SectionCommunity';
const SectionCommunity = memo(SectionCommunityComponent);

export default SectionCommunity;
